export default __webpack_public_path__ + "static/media/rank-Button-PNG.7d60b25c.webp";